export default __webpack_public_path__ + "static/media/lp-icon.9b0f8540.svg";